import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { storeSearchShipment } from 'store/reducers/mainSlice';
import Pagination from 'ui-component/Pagination';
import Scroller from 'ui-component/Scroller';
import moment from 'moment';
import { FaSearch } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { Skeleton, Tooltip } from '@mui/material';
import toast from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import CurrencyValue from 'ui-component/CurrencyValue';
import usePermissions from 'hooks/usePermissions';
import usePageTitle from 'hooks/usePageTitle';
import { ViewDetailsIcon, DeleteIcon } from 'ui-component/custom-icons/icons';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import useIsMobile from 'utils/isMobileUtils';
import { FiTrash2 } from 'react-icons/fi';
import StatusBadge from 'ui-component/StatusBadge';
import StatusText from 'ui-component/StatusText';
// ✅ Clear
const Shipments = () => {
	const [setPageTitle] = usePageTitle('Shipments');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const [params, setParams] = useSearchParams();
	const history = useNavigate();
	const [allPermissions, hasEveryPermission] = usePermissions();
	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
	const [shipmentList, setShipmentList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [pagination, setpagination] = useState([]);
	const dispatch = useDispatch();
	// const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [selectedShipment, setSelectedShipment] = useState(null);
	const [searchField, setSearchField] = useState();
	const [searchValue, setSearchValue] = useState();
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [filters, setFilters] = useState([]);
	const [activeFilters, setActiveFilters] = useState({});

	const storedSearch = useSelector((state) => state.main.searchShipment);
	const storedFilter = useSelector((state) => state.main.filterShipment);

    // useEffect(() => {

    //     const fetchData = async () => {
    //         if (storedSearch) {
    //             setIsLoading(true);
    //             await handleSearch({ target: { value: storedSearch } });
    //         } else if (!storedSearch) {
    //             if (storedFilter && Object.keys(storedFilter).length > 0) {
    //                 setIsLoading(true);
    //                 await handleFilterRedux();
    //             } else {
    //                 handleFilter()
    //             }
    //         }
    //     };

    //     fetchData();
    // }, [storedSearch, searchField, activeFilters, storedFilter]);
	

	const handleSearch = (e) => {
		let text = e.target.value;
		
		setIsLoading(true);
		setSearchValue(text);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		// Only update searchField after user stops typing for 500ms
		let timeout = setTimeout(() => {
			dispatch(storeSearchShipment(text));
			setSearchField(text)	
		}, 500);

		setSearchTimeout(timeout);
		// let text = e.target.value;
		// setSearchField(text);

        // dispatch(storeSearchShipment(text));
		// if (searchTimeout) {
		// 	clearTimeout(searchTimeout);
		// }

		// let timeout = setTimeout(() => {
		// 	setIsLoading(true);
		// 	if (text.length > 2) {
		// 		api.filterShipments(activeFilters, text).then((res) => {
		// 			setIsLoading(false);
		// 			setShipmentList(res.data.data);
		// 			setpagination(res.data);
		// 		});
		// 	} else if (text.length > 0 && text.length <= 2) {
		// 		setIsLoading(false);
		// 	} else {
		// 		api.filterShipments(activeFilters, null).then((res) => {
		// 			setIsLoading(false);
		// 			setShipmentList(res.data.data);
		// 			setpagination(res.data);
		// 		});
		// 	}
		// }, 1000);

		// setSearchTimeout(timeout);
	};

	const viewData = (source, id) => {
		if (source === 'shipment') {
			history(`/shipments/${id}`);
		} else if (source === 'picklist') {
			window.open(`/picklists/${id}`, '_blank');
		} else if (source === 'sales_order') {
			window.open(`/sales/sales-orders/${id}`, '_blank');
		} else if (source === 'contact') {
			window.open(`/contacts/${id}`, '_blank');
		}
	};


	// useEffect(() => {
	// 	handleFilter();
	// }, [activeFilters]);

	const handleFilter = (activeF = null, searchF = null) => {
		setIsLoading(true);
		api.filterShipments(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
			setIsLoading(false);
			setShipmentList(res.data.data);
			setpagination(res.data);
		});
	};

	const handleFilterRedux = (activeF = null, searchF = null) => {
		setIsLoading(true);
		api.filterShipments(storedFilter, searchField?.length > 2 ? searchField : null).then((res) => {
			setIsLoading(false);
			setShipmentList(res.data.data);
			setpagination(res.data);
		});
	};


	useEffect(() => {
		setTimeout(() => {
		}, 100);
	}, []);


	const handleDeleteShipment = (data) => {
		setSelectedShipment(data);
		setShowDeleteModal(true)
	};

	const handleClose = () => {
		setShowDeleteModal(false);
	} 

	const handleData = (data) => {
		setShipmentList(data.data);
		setpagination(data);
	};

	useEffect(() => {
		getFiltersList();
	}, []);

	useEffect(() => {
		if (params.get('create') == 'shipment') {
			setParams({});
		}
	});

	const getFiltersList = () => {
		api.getShipmentFilters().then((res) => {
			setFilters(res.data);
		});
	};

	const isMobile = useIsMobile();


    const areAnyItemsChecked = () => {
        return dataList.some(item => item.isChecked);
    };


	const [dataList, setDataList] = useState([]);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const tableRef = useRef();
	const [showPreloadingRows, setShowPreloadingRows] = useState(true);
	const [totalRecords, setTotalRecords] = useState(0);

	const [sortByFilter, setSortByFilter] = useState();
	const [isAllChecked, setIsAllChecked] = useState(false);
	const [checkedItems, setCheckedItems] = useState([]);
	const [showDeleteButton, setShowDeleteButton] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);





	const initializeData = () => {
		// Initial load
		let request = {}
		request.page = 1;
		request.search = searchField?.length > 2 ? searchField : null;
		
		
		api.getShipmentLists(request, activeFilters, searchField, sortByFilter).then((res) => {
			
			setDataList([]);
			setTimeout(() => {
				setDataList(res?.data?.data?.data || []);

				setHasMore(true);
				setPage(1);
				// dispatch(setLoading(false));
				setIsLoading(false);
				setShowPreloadingRows(false);
				setTotalRecords(res?.data?.data?.total || 0);
			}, 300);
		});

	}


	useEffect(() => {
		// Only run fetchData after user stops typing (debounced by searchTimeout)
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const timeout = setTimeout(() => {
			const fetchData = async () => {
				if (storedSearch) {
					await handleSearch({ target: { value: storedSearch } });
				}
				setDataList([]);
				initializeData();
				getFiltersList();
			};
			fetchData();
		}, 500); // 500ms debounce

		setSearchTimeout(timeout);

		// Cleanup on unmount or before next effect run
		return () => clearTimeout(timeout);
		// Only trigger when these change
	}, [storedSearch, searchField, storedFilter]);

	useEffect(() => {
		setIsLoading(true);
	}, [activeFilters])



	useEffect(() => {
		const handleScroll = () => {
			if (!tableRef.current || showPreloadingRows || !hasMore) return;
			const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
			// Trigger only when user reaches the bottom (with a small threshold)
			if (scrollTop + clientHeight >= scrollHeight - 10) {
				loadMoreData();
			}
		};
		const currentRef = tableRef.current;
		if (currentRef) {
			currentRef.addEventListener('scroll', handleScroll);
		}
		return () => {
			if (currentRef) {
				currentRef.removeEventListener('scroll', handleScroll);
			}
		};
	}, [showPreloadingRows, hasMore, dataList]);

    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        
        api.getShipmentLists(request, activeFilters, searchField, sortByFilter).then((res) => {
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };




	const handleCheckAll = () => {
		let updatedCheckedItems = [];
		let updatedCheckedItemsStatus = [];

		if (isAllChecked) {
			// Uncheck all
			setCheckedItems([]);
			setIsAllChecked(false);
		} else {
			// Check all
			updatedCheckedItems = dataList.map(item => item.id);
			setCheckedItems(updatedCheckedItems);
			setIsAllChecked(true);
		}
	};

	useEffect(() => {
		// Show delete button if there are any checked items
		setShowDeleteButton(checkedItems.length > 0);
	}, [checkedItems]);

	const handleCheckItem = (id) => {
		let updatedCheckedItems;

		if (checkedItems.includes(id)) {
			updatedCheckedItems = checkedItems.filter(itemId => itemId !== id);
			// Remove the status at the same index as the unchecked id
			const removeIndex = checkedItems.findIndex(itemId => itemId === id);
			setCheckedItems(updatedCheckedItems);
			setIsAllChecked(false);
		} else {
			updatedCheckedItems = [...checkedItems, id];
			setCheckedItems(updatedCheckedItems);
			if (updatedCheckedItems.length === dataList.length) setIsAllChecked(true);
		}

	};


	const handleDelete = () => {
		toast.promise(
			api.deleteShipmentTracking(selectedShipment?.id).then((res) => {
				if (res?.status) {
					handleClose();
					setSelectedShipment(null);
				}
				return res?.status ? res : null;
			}),
			{
				loading: 'Deleting Shipment...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete shipment</b>
			}
		);
	}

	const handleDeleteMultipleRecords = () => {
		toast.promise(
			api.deleteMultipleShipments({ checkedItems }).then((res) => {
				if (res.status) {
					setIsLoading(true);
					setDataList([]);
					initializeData();
					setIsAllChecked(false);
					setCheckedItems([]);
					setShowDeleteButton(false);
					setShowDeleteModal(false);
				}

				return res?.status ? res : abc;
			}),
			{
				loading: 'Deleting Records...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete records</b>
			}
		);
	}

	return (
		<>
			<div className="row">
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<h5 style={{ textAlign: 'center' }}>Shipments</h5>
							<div style={{ height: 10, opacity: 0 }}></div>
						</div>
					</div>

					<div className="section-head hide-on-mobile">
					</div>
					<div
						className="show-on-mobile"
						style={{
							display: 'flex',
							paddingLeft: 20,
							paddingRight: 20,
							paddingTop: 0,
							paddingBottom: 0,
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10
						}}
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									value={searchValue || ''}
									onChange={handleSearch}
									style={{ width: '100%', paddingRight: 36 }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
						<div style={{ flexShrink: 0 }}>
							<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} multi={undefined} source={'shipment'} />
						</div>
					</div>
					{/* <div className={`card shadow-sm  bg-white mb-4  ${isMobile ? 'table-card shorter-table' : ''}`}> */}
					<div className={`card shadow-sm  bg-white table-card ${Object.keys(activeFilters).length !== 0 ? 'has-filter' : '' }`}>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<Filter activeFilters={activeFilters} onSubmit={setActiveFilters} filters={filters} multi={undefined} source={'shipment'} />
							</div>
							<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
						{!isMobile ? (
							<div
								className="table-responsive-xl tableData estimationList"
								ref={tableRef}
								style={{
									height: 'calc(100vh - 260px)',
									overflowY: 'auto',
									scrollbarWidth: 'thin',
									scrollbarColor: '#0966ff transparent'

								}}
							>
								<table className="table pm-table">
									<thead>
										<tr className="sticky-header">
											<th scope="col" className="text-center align-middle" style={{ width: '50px' }}>
												<input 
													type="checkbox" 
													className="pm-checkbox"
													checked={isAllChecked}
													onChange={handleCheckAll}
												/>
											</th>
											<th scope="col">Tracking Number</th>
											<th scope="col">Reference</th>
											{/* <th scope="col">Provider</th> */}
											<th scope="col">Receiver</th>
											<th scope="col">Status</th>
											{/* <th scope="col">Created</th> */}
										</tr>
									</thead>
									<tbody>
										{isLoading ? (
											[...Array(100)].map((e, i) => (
												<tr style={{ height: '35px' }}>
													{[...Array(5)].map((e, i) => (
														<td>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
														</td>
													))}
												</tr>
											))
										) : (
											<>
												{dataList?.length > 0 && (
													dataList?.map((row, index) => {
														return (
															<tr key={index} className="hover-row h-35">
																<td className="text-center align-middle">
																	<input
																		type="checkbox"
																		className="pm-checkbox"
																		checked={checkedItems.includes(row.id)}
																		onChange={() => {
																			// if (row?.status !== 'Delivered') {
																				handleCheckItem(row.id, row?.status)
																			// }
																		}}
																	/>
																</td>
																<td
																	className="align-middle"
																	onClick={() => {
																		viewData('shipment', row.id);
																	}}
																>
																	<div
																		className="cursor-pointer text-primary"
																	>
																		{row?.tracking_number}
																	</div>
																</td>
																<td className={`align-middle`}>
																	{row?.shipments?.length > 0 && (
																		<div className="d-flex justify-left items-center gap-4">
																			{row?.shipments?.slice(0, 2).map((shipment, index) => (
																				<React.Fragment key={index}>
																					<div
																						className={`${
																							hasEveryPermission(['View Sales Orders Details']) ? 'cursor-pointer text-primary' : ''
																						}`}
																						onClick={() => {
																							if (hasEveryPermission(['View Sales Orders Details'])) {
																								viewData('sales_order', shipment?.sales_order?.id);
																							}
																						}}
																					>
																						{shipment?.sales_order?.sales_order_number}
																						{index < Math.min(row.shipments.length, 2) - 1 && ','}
																					</div>
																				</React.Fragment>
																			))}
																			{row?.shipments?.length > 2 && (
																				<div className="more_label_container">+{row.shipments.length - 2} more</div>
																			)}
																		</div>
																	)}
																</td>
																{/* <td
																	className="align-middle"
																	onClick={() => {
																		viewData('shipment', row.id);
																	}}
																>
																	{row?.shipping_company?.name}
																</td> */}
																<td className={`align-middle`}>
																	{row?.shipments?.length > 0 && (
																		<div className="d-flex justify-left items-center gap-4">
																			{row?.shipments?.slice(0, 1).map((shipment, index) => (
																				<React.Fragment key={index}>
																					<div
																						className={`${
																							hasEveryPermission(['View Contact (Button)']) ? 'cursor-pointer text-primary' : ''
																						}`}
																						onClick={() => {
																							if (hasEveryPermission(['View Contact (Button)'])) {
																								viewData('contact', shipment?.receiver?.id);
																							}
																						}}
																					>
																						{shipment?.receiver?.name}
																						{index < Math.min(row.shipments.length, 1) - 1 && ','}
																					</div>
																				</React.Fragment>
																			))}
																			{row?.shipments?.length > 2 && (
																				<div className="more_label_container">+{row.shipments.length - 1} more</div>
																			)}
																		</div>
																	)}
																</td>
																<td
																	className="align-middle"
																	onClick={() => {
																		viewData('shipment', row.id);
																	}}
																>
																	<StatusBadge itemStatus={row?.status ? row.status.toUpperCase() : ''} />
																</td>
																{/* <td
																	className="align-middle"
																	onClick={() => {
																		viewData('shipment', row.id);
																	}}
																>
																	{moment(row?.created_date).format(CommonDateOnlyFormat)}
																</td> */}

																{/* <td className="hover-button-container">
																	<div>
																		<div className="hover-button">
																			<PermissionAllowed permissions={['View Shipment (Button)']}>
																				<Tooltip title={'View'} arrow placement="top">
																					<div
																						className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																						style={{ marginLeft: '8px' }}
																						onClick={() => {
																							viewData('shipment', row.id);
																						}}
																					>
																						<ViewDetailsIcon height={'16'} width={'16'} />
																					</div>
																				</Tooltip>
																			</PermissionAllowed>

																			<PermissionAllowed permissions={['Delete Shipment (Button)']}>
																				<Tooltip title={'Delete'} arrow placement="top">
																					<div
																						className="btn btn-danger white-var btn-sm cursor-pointer"
																						style={{ marginLeft: '8px' }}
																						onClick={() => {
																							handleDeleteShipment(row);
																						}}
																					>
																						<div style={{ margin: 'auto 3px' }}>
																							<DeleteIcon height="14px" width="14px" />
																						</div>
																					</div>
																				</Tooltip>
																			</PermissionAllowed>
																		</div>
																	</div>
																</td> */}
															</tr>
														);
													})
												)}
												{showPreloadingRows && (
													[...Array(100)].map((e, i) => (
														<tr style={{ height: '35px' }} key={i}>
															{[...Array(5)].map((e, i) => (
																<td>
																	<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																</td>
															))}
														</tr>
													))
												)}
												{(dataList?.length < 1 && !isLoading) && (
													<tr className="no-hover">
														<td colSpan={5} className="whitebg">
															<div className="not-found-container">
																	<div className="not-found-icon">
																	<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																	
																</div>
																<h6 className="not-found-text">No Data Available</h6>

															</div>
														</td>
													</tr>
												)}
											</>
										)}
									</tbody>
								</table>
							</div>
						) : (
							
							<div
								className="table-responsive-xl tableData estimationList"
								ref={tableRef}
								style={{
									height: `calc(100dvh - ${Object.keys(activeFilters).length === 0 ? '280px' : '295px' })`,
									overflowY: 'auto',
									display: 'flex',
									flexDirection: 'column'
								}}
							>
									
								<div className="inv-cards-list d-md-none">


									{isLoading ? (
										[...Array(50)].map((_, idx) => (
											<div
												key={idx}
												className="order-list-card"
												style={{
													background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
													marginBottom: 10,
													borderRadius: 12,
													padding: 16,
													display: 'flex',
													flexDirection: 'column',
													gap: 10
												}}
											>
												{[...Array(2)].map((__, i) => (
													<div key={i} style={{ width: '100%' }}>
														<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
													</div>
												))}
											</div>
										))
									) : dataList?.length > 0 ? (
										dataList?.map((item, index) => (
											<div
												className="order-list-card active-action"
												style={{
													background: index % 2 === 0 ? '#f9f9f9' : '#fff'
												}}
												onClick={() => viewData('shipment', item.id)}
											>
												<div className="order-list-card-header">
													<h6 className="order-no">
														{item?.tracking_number}
													</h6>
													<div className="order-date text-right">
														<StatusText itemStatus={item?.status} />
													</div>
												</div>

												<div className="order-list-card-body">
													<div className="w-full flex" style={{ justifyContent: 'space-between' }}>
														<div className="order-customer flex" style={{ gap: '5px'}}>
															{item?.shipments?.slice(0, 2).map((shipment, idx) => (
																<div key={idx}>
																	{shipment?.sales_order?.sales_order_number}
																	{idx < Math.min(item.shipments.length, 2) - 1 && ', '}
																</div>
															))}
															{item?.shipments?.length > 2 && <div className="more_label_container" style={{ border: 0 }}>+{item.shipments.length - 2} more</div>}
														</div>
														<div className="order-customer flex" style={{ gap: '5px'}}>
															{item?.shipments?.slice(0, 1).map((shipment, idx) => (
																<div key={idx}>
																	{shipment?.receiver?.name}
																	{idx < Math.min(item.shipments.length, 1) - 1 && ', '}
																</div>
															))}
															{item?.shipments?.length > 2 && <div className="more_label_container" style={{ border: 0 }}>+{item.shipments.length - 1} more</div>}
														</div>
													</div>
												</div>

											</div>
										))
									) : (
										<div className="not-found-container">
											<div className="not-found-icon">
												<img src={NoRecordFoundIcon} style={{ height: '120px', width: '120px' }} />
											</div>
											<h6 className="not-found-text">No Data Available</h6>
									
										</div>
									)}
										
								</div>
							</div>
						)}
						
						<div
							className="hide-on-mobile"
							style={{
								padding: '10px 0px 10px 20px',
								borderTop: '1px solid #e0e0e0e0',
								display: 'flex',
								gap: '5px',
								justifyContent: 'space-between',
								height: '45px',
							}}
						>

							<div className="flex align-items-center" style={{ gap: '10px' }}>
								{
									showDeleteButton && (
										<>
											<button 
												className="btn btn-danger btn-outlined-main-danger white-va"
												onClick={() => {
													setShowDeleteModal(true);
												}}
											>
												Delete
											</button>
											<div>
												<span className="text-gray-800">Selected:</span>{' '}
												<span className="fw-500">
													{checkedItems.length ? checkedItems.length.toLocaleString('en-US') : 0}
												</span>
											</div>
										</>
									)
								}
							</div>
							<div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
								{isLoading ? (
									<div style={{ width: '100px' }}>
										<Skeleton variant="rounded" width={'100%'} height={20} />
									</div>
								) : (
									<>
										<div className="text-gray-800">Total Record:</div>
										<div className="fw-500">
											{totalRecords.toLocaleString('en-US')}
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{showDeleteModal && (
				<DeleteConfirmation
					show={showDeleteModal}
					handleClose={handleClose}
					handleDelete={handleDeleteMultipleRecords}
					title="Confirm"
					message={`Are you certain you wish to delete the selected shipment record(s)? This action cannot be undone.`}
					customDeleteButtonText={`Yes, Delete selected shipment(s)`}
				/>
			)}
		</>
	);
};

export default Shipments;
